import type { MinistryTypeKey } from '@/shared/types/ministry';
import { MinistryTypes } from '@/store/org/types';
import { Select, SelectItem, type SharedSelection } from '@/components/ui';
import { Icon } from '../icon';
import { useMemo, useState } from 'react';

export function MinistryTypeSelect({
  label,
  value = '',
  onChange,
  className,
  placeholder,
}: {
  label?: string;
  value?: '' | MinistryTypeKey;
  onChange: (type: '' | MinistryTypeKey) => void;
  className?: string;
  icons?: boolean;
  placeholder?: string;
  plural?: boolean;
}) {
  const icons = useMemo(
    () =>
      MinistryTypes.reduce(
        (m, v) => {
          m[v.key] = v.icon;

          return m;
        },
        {} as Record<MinistryTypeKey, string>,
      ),
    [],
  );
  const [selected, setSelected] = useState<'' | MinistryTypeKey>('');
  const changeHandler = (key: SharedSelection) => {
    if (!key) {
      setSelected('');
      onChange('');
    } else if (key instanceof Set) {
      const [sel] = key;
      let value = sel as '' | MinistryTypeKey;
      value ??= '';
      setSelected(value);
      onChange(value);
    }
  };

  const startContent =
    selected === '' ? undefined : <Icon icon={icons[selected]} />;

  return (
    <Select
      label={label}
      aria-label='Select Type'
      items={MinistryTypes}
      defaultSelectedKeys={[value]}
      onSelectionChange={changeHandler}
      className={className}
      startContent={startContent}
      placeholder={placeholder}
    >
      {MinistryTypes.map((item) => (
        <SelectItem
          key={item.key}
          startContent={<Icon icon={item.icon} width={20} />}
        >
          {item.name}
        </SelectItem>
      ))}
    </Select>
  );
}
